import posthog from "posthog-js";

// PostHog is initialized with a placeholder key.
// Replace with your actual PostHog project API key.
// To get your key:
//   1. Go to https://us.posthog.com (or eu.posthog.com)
//   2. Create a free account / project
//   3. Go to Settings → Project → Project API Key
//   4. Copy the key and paste it below

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY || "__POSTHOG_KEY__";
const POSTHOG_HOST =
  process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com";

if (POSTHOG_KEY && POSTHOG_KEY !== "__POSTHOG_KEY__") {
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: "always",
    capture_pageview: false, // we fire pageviews manually for SPA routing
    capture_pageleave: true,
    session_recording: {
      maskAllInputs: false,
      maskTextSelector: "", // don't mask any text — it's a valentine's site, no sensitive data
    },
  });
}

export default posthog;
